import React from 'react'
import { NavigationMenuLink } from '@/components/ui/navigation-menu'
import { cn } from '@/lib/utils'
import type { ToolItemProps } from '@/types/components'

export const ToolItem = React.forwardRef<React.ComponentRef<'a'>, ToolItemProps>(
  ({ className, title, description, icon: Icon, ...props }, ref) => {
    return (
      <div>
        <NavigationMenuLink asChild>
          <a
            ref={ref}
            className={cn(
              'block select-none rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground',
              className,
            )}
            {...props}
          >
            <div className="font-semibold tracking-tight leading-none flex items-center gap-2">
              <Icon className="h-4 w-4 text-muted-foreground" />
              {title}
            </div>
            <p className="mt-2 line-clamp-2 text-sm leading-snug text-muted-foreground">
              {description}
            </p>
          </a>
        </NavigationMenuLink>
      </div>
    )
  },
)

ToolItem.displayName = 'ToolItem'
